<template>
    <div>
      <!--<div style="text-align: left;margin-bottom: 10px">
        <el-button type="primary" size="small" icon="el-icon-download" @click="downloadResumeTemplate">模板下载</el-button>
        <el-upload
          class="upload-resume-template"
          :action="UPLOAD_URI"
          :headers="{'auth-user': $store.get('Authorization')}"
          :data="{instanceName: 'tab_user'}"
          :show-file-list="false"
          :on-progress="uploadingFile"
          :on-success="uploadSuccess"
          :accept="'.xlsx'">
          <el-button size="small" :icon="uploadIcon" type="primary">简历导入</el-button>
        </el-upload>
      </div>-->
      <el-table
        ref="multipleTable"
        width="100%"
        border
        maxHeight="800"
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          fixed="left"
          prop="userName"
          :show-overflow-tooltip="true"
          label="姓名"
          width="130">
          <template slot-scope="scope">
            <span class="user-name" @click="showResume(scope.row)">{{scope.row.userName ? scope.row.userName : '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="positionName"
          label="所投职位"
          width="160"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          label="工作年限"
          width="100"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.workingLife ? scope.row.workingLife / 10 + '年' : '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="学历"
          width="60"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.educationDict ? scope.row.educationDict.dictName : '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="jobStatus"
          label="求职状态"
          width="120"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.jobStatus ? scope.row.jobStatus : '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式"
          width="110"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.phone ? scope.row.phone : '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="introduce"
          label="个人简介"
          width="500"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.introduce ? scope.row.introduce : '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          prop="isChecked"
          label="状态"
          width="80"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span :style="stateColor(showStatus(scope.row))">{{showStatus(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100">
          <template slot-scope="scope">
            <span class="op-icon op-view" :class="statusDisabled(scope.row, 'isChecked') ? 'op-disabled' : ''" :title="showStatusTitle(scope.row, 'mark')" @click="markCheckedStatus(scope.row, 'isChecked', 2)"><i class="el-icon-view"></i></span>
            <span class="op-icon op-refuse" :class="statusDisabled(scope.row, 'isAccept') ? 'op-disabled' : ''" :title="showStatusTitle(scope.row, 'refuse')" @click="markCheckedStatus(scope.row, 'isAccept', 1)"><i class="el-icon-close"></i></span>
            <span class="op-icon op-receive" :class="statusDisabled(scope.row, 'isAccept') ? 'op-disabled' : ''" :title="showStatusTitle(scope.row, 'accept')" @click="markCheckedStatus(scope.row, 'isAccept', 2)"><i class="el-icon-check"></i></span>
            <span class="op-icon op-download" title="下载简历" @click="downloadResume(scope.row)"><i class="el-icon-bottom"></i></span>
          </template>
        </el-table-column>
      </el-table>

      <user-resume v-if="showUserResumeFlag" :showUserResumeFlag="showUserResumeFlag" :userResume="showUserResumeObj" @hideUserResume="hideUserResume()"></user-resume>
    </div>
</template>

<script>
import utilService from '../../utils/utilService'
import UserResume from './UserResume'

export default {
  name: 'ReceiveResumes',
  components: {UserResume},
  data () {
    return {
      UPLOAD_URI: location.origin + '/recurit/user/batchUserInfo',
      tableData: [],
      multipleSelection: [],
      showUserResumeFlag: false,
      showUserResumeObj: null,
      uploadIcon: 'el-icon-upload2'
    }
  },
  methods: {
    downloadResumeTemplate () {
      utilService.downLoadFile(`${this.$api.getResumeTemplate.url}?name=个人信息模板&suffix=xlsx&pelativePath=template`, `个人信息模板.xlsx`)
    },
    uploadResumeTemplate () {

    },
    uploadingFile () {
      this.uploadIcon = 'el-icon-loading'
    },
    uploadSuccess (response) {
      this.uploadIcon = 'el-icon-upload2'
      console.log(response)
      let _ = JSON.parse(response)
      if (_ && _.code === 200) {
        this.$message.success('导入成功！')
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(val)
    },
    showStatus (item) {
      return (!item.isAccept || item.isAccept === 0) ? (parseInt(item.isChecked) === 1 ? '未查看' : '已查看') : (item.isAccept === 1 ? '已拒绝' : '已接受')
    },
    showStatusTitle (item, type) {
      if ((!item.isAccept || item.isAccept === 0) && item.isChecked === 1 && type === 'mark') {
        return '标记为已查看'
      }
      if ((!item.isAccept || item.isAccept === 0) && item.isChecked === 2 && type === 'mark') {
        return '已查看'
      }
      if (item.isAccept) {
        return `状态为${item.isAccept === 1 ? '已拒绝' : '已接受'}的不能再操作`
      }
      if ((!item.isAccept || item.isAccept === 0) && type === 'refuse') {
        return `简历不通过，拒绝`
      }
      if ((!item.isAccept || item.isAccept === 0) && type === 'accept') {
        return `简历通过，接受并把简历发送到我的邮箱`
      }
    },
    statusDisabled (item, type) {
      if (item.isAccept && item.isAccept !== 0) {
        return item.isAccept && item.isAccept !== 0
      }
      if (type === 'isChecked') {
        return item.isChecked === 2
      }
    },
    stateColor (state) {
      let cls = null
      switch (state) {
        case '未查看':
          cls = {color: '#E6A23C'}
          break
        case '已查看':
          cls = {color: '#409EFF'}
          break
        case '已拒绝':
          cls = {color: '#F56C6C'}
          break
        case '已接受':
          cls = {color: '#67C23A'}
          break
      }
      return cls
    },
    markCheckedStatus (item, op, val) {
      if (item.isAccept && item.isAccept !== 0) {
        return false
      }

      let p = {
        positionId: item.positionId,
        userCode: item.userCode
      }

      if (op === 'isAccept' && item[op] === 0 && val === 2) {
        this.$http.get(this.$api.sendEmail.url, {
          userCode: item.userCode
        }).then(_ => {
          if (_ && _.code === 200) {
            this.$message.success(`求职者 ${item.userName} 的简历已发送到我的邮箱，请注意查收！`)
          } else {
            this.$message.error(`求职者 ${item.userName} 的简历已发送到我的邮箱失败！`)
          }
        })
      }

      if ((op === 'isChecked' && item[op] === 1) || (op === 'isAccept' && item[op] === 0)) {
        p[op] = val
        this.$http.post(this.$api.createOrUpdateRelation.url, p).then(_ => {
          if (_ && _.code === 200) {
            item[op] = val
            if (op === 'isChecked') {
              this.$message.success(`已标记为查看！`)
            }
            if (op === 'isAccept' && val === 1) {
              this.$message.success(`简历不通过，已拒绝！`)
            }
          }
        })
      } else {
        return false
      }
    },
    downloadResume (item) {
      this.$http.get(this.$api.getUsrResume.url, {
        userCode: item.userCode
      }).then(_ => {
        utilService.downloadFileForStream(_, `个人简历_${item.userName || ''}.doc`, 'application/msword')
      })
    },
    showResume (row) {
      this.showUserResumeObj = row
      this.showUserResumeFlag = true
    },
    hideUserResume () {
      this.showUserResumeObj = null
      this.showUserResumeFlag = false
    }
  },
  mounted () {
    if (this.$store.get('user')) {
      this.$http.get(this.$api.getApplyResume.url).then(_ => {
        if (_ && _.code === 200 && _.data) {
          this.tableData = _.data || []
        }
      })
    }

    if (location.origin.includes('127.0.0.1') || location.origin.includes('localhost')) {
      this.UPLOAD_URI = location.origin + '/api/recurit/user/batchUserInfo'
    }
  }
}
</script>

<style scoped>
.op-icon {
  cursor: pointer;
  font-size: 16px;
}
.op-view:hover {
  color: #E6A23C;
}
.op-refuse:hover {
  color: #F56C6C;
}
.op-receive:hover {
  color: #67C23A;
}
.op-download:hover {
  color: #409EFF;
}
.op-disabled {
  color: #cccccc;
  cursor: not-allowed;
}
.op-disabled:hover {
  color: #cccccc;
}
  .user-name {
    cursor: pointer;
  }
  .user-name:hover {
    color: #409eff;
  }
  .upload-resume-template {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Recruit/ReceiveResumes.vue